import { dew as _VersionsPostRequestBodyDew } from "./VersionsPostRequestBody";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.VersionsPostRequestBody = void 0;
  var VersionsPostRequestBody_1 = _VersionsPostRequestBodyDew();
  Object.defineProperty(exports, "VersionsPostRequestBody", {
    enumerable: true,
    get: function () {
      return VersionsPostRequestBody_1.VersionsPostRequestBody;
    }
  });
  return exports;
}